import React, { MouseEventHandler, useMemo } from "react";

import { i18nService } from "services";
import { Button } from "components";
import { Filter } from "assets/icons";

interface FacetsTriggerProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  nbActiveFacets?: number;
}

export const FacetsTrigger: React.FC<FacetsTriggerProps> = ({
  nbActiveFacets,
  onClick,
}) => {
  const buttonText = useMemo(() => {
    if (nbActiveFacets) {
      return `${i18nService.copy["facets.mobileTrigger"]} • ${nbActiveFacets}`;
    }

    return i18nService.copy["facets.mobileTrigger"];
  }, [nbActiveFacets]);

  return (
    <Button
      PrefixIcon={Filter}
      layout="block"
      text={buttonText}
      onClick={onClick}
    />
  );
};
